module.exports = __webpack_public_path__ + "icomoon.383998818da15eb6ad6f.woff";


//////////////////
// WEBPACK FOOTER
// G:/UTL/Alumni/Alumni-ANG/src/assets/fonts/icomoon.woff?mm9zby
// module id = ../../../../../src/assets/fonts/icomoon.woff?mm9zby
// module chunks = styles